import { render, staticRenderFns } from "./PT461ItemReviewParts.vue?vue&type=template&id=b28783c4&"
import script from "./PT461ItemReviewParts.vue?vue&type=script&lang=js&"
export * from "./PT461ItemReviewParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports